import { Link } from "wouter";
import { trpc } from "../../main/components/ProviderContainer.tsx";

interface ImportedInvoiceReceiptProps {
  documentIds: string[];
}

const ImportedInvoiceReceipt = ({ documentIds }: ImportedInvoiceReceiptProps) => {
  const { data: pendingDocs, isFetching, error } =
    trpc.facture.getImportedInbox.useQuery(undefined, {
      enabled: documentIds.length > 0,
    });
  const receivedIds = new Set(documentIds);
  const receivedCount = receivedIds.size;
  const pendingCount = pendingDocs?.filter((doc) =>
    receivedIds.has(doc._id),
  ).length;

  return (
    <div className="alert alert-info mt-3 mb-0" role="status">
      {receivedCount > 0 ? (
        <>
          {receivedCount} document{receivedCount > 1 ? "s" : ""} reçu
          {receivedCount > 1 ? "s" : ""}.{" "}
          {error ? (
            "Le bilan est indisponible pour le moment."
          ) : isFetching || pendingCount === undefined ? (
            "Actualisation du bilan..."
          ) : (
            <>
              {receivedCount - pendingCount} traité
              {receivedCount - pendingCount > 1 ? "s" : ""}, {pendingCount}{" "}
              {pendingCount > 1 ? "restent" : "reste"} à traiter.
            </>
          )}{" "}
        </>
      ) : null}
      Les PDF reçus et non finalisés restent accessibles dans « À traiter »,
      même après fermeture de cette page ou erreur d'analyse. Retirer une ligne
      de ce tableau ne supprime pas le document enregistré.{" "}
      <Link href="/importedFactures" className="alert-link">
        Voir les factures à traiter
      </Link>
    </div>
  );
};

export default ImportedInvoiceReceipt;
